import Link from 'next/link'
import styles from './SearchTagList.module.scss'
import { CSSProperties } from 'react'

interface SearchTagListProps {
  currentCategory?: string
}

const SearchTagList: React.FC<SearchTagListProps> = ({ currentCategory }) => {
  const isDisabled: CSSProperties = currentCategory ? { pointerEvents: 'none' } : {}

  const categoryGroups = [
    [
      //{ name: 'AI駆動開発支援', link: '/cases/ai-driven-development/' },
      { name: 'アプリケーション開発', link: '/cases/application-development/' },
      { name: 'クラウドネイティブ', link: '/cases/cloudnative/' },
      //{ name: 'モダナイゼーション', link: '/cases/modernization/' },
      //{ name: '特徴量エンジニアリングと生成AI', link: '/cases/feature-engineering/' },
    ],
    [
      { name: 'デザインシステム構築支援', link: '/cases/design-system/' },
      { name: 'プロトタイピング・仮説検証', link: '/cases/prototyping/' },
      { name: 'UX/UI改善', link: '/cases/uxui-improvement/' },
      { name: 'フロントエンド開発', link: '/cases/frontend-dev/' },
    ],
    [
      { name: 'PdM/PMM体制実行支援', link: '/cases/pdm-pmm/' },
      { name: '新規事業プロジェクト実行支援', link: '/cases/business-startup-support/' },
    ],
    [
      { name: 'flamingo', link: '/cases/flamingo/' },
      { name: 'ZEBRA', link: '/cases/zebra/' },
    ],
    [
      { name: '内製化支援', link: '/cases/inhouse-support/' },
      { name: 'AI', link: '/cases/ai/' },
      { name: '組織開発・人材育成', link: '/cases/hip/' },
    ],
  ]

  const industryCategories = [
    { name: 'IT/情報/通信', link: '/cases/telecommunications/', color: 'gray' },
    { name: 'メーカー/製造/建設', link: '/cases/manufacturing/', color: 'gray' },
    { name: '金融/不動産', link: '/cases/finance/', color: 'gray' },
    { name: '小売/流通/卸', link: '/cases/retail/', color: 'gray' },
    { name: 'サービス', link: '/cases/service/', color: 'gray' },
    { name: '公共/行政', link: '/cases/public/', color: 'gray' },
  ]

  const renderCategoryItem = (category: { name: string; link: string; color?: string }) => {
    const isActive = currentCategory === category.name
    const isGray = category.color === 'gray'

    return (
      <li key={category.name} className={styles.btnlist_li}>
        {isActive ? (
          <span className={`${styles.btnlist_a} ${isActive ? styles.btnlist_active : ''}`}>{category.name}</span>
        ) : (
          <Link href={category.link} passHref>
            <a
              href={category.link}
              className={`${styles.btnlist_a} ${isGray ? styles.gray : ''}`}
              style={isActive ? isDisabled : {}}
            >
              {category.name}
            </a>
          </Link>
        )}
      </li>
    )
  }

  return (
    <ul className={styles.searchlist}>
      <li className={styles.searchlist_ul}>
        <div className={styles.searchhead}>サービスから探す</div>
        {categoryGroups.map((group, index) => (
          <ul className={styles.btnlist} key={index}>
            {group.map(renderCategoryItem)}
          </ul>
        ))}
      </li>
      <li className={styles.searchlist_ul}>
        <div className={styles.searchhead}>業界から探す</div>
        <ul className={styles.btnlist}>{industryCategories.map(renderCategoryItem)}</ul>
      </li>
    </ul>
  )
}

export default SearchTagList
